import { memo } from 'react';
import { ProfileEditTemplate } from 'components/templates/ProfileEditTemplate';

type Props = {};

export const ProfileEditPage = memo((_props: Props) => {
	return <ProfileEditTemplate />;
});
